"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _actionMenuTypes = _interopRequireDefault(require("../app-action-menu/action-menu-types"));

var _default = _propTypes.default.arrayOf(_propTypes.default.oneOf([_actionMenuTypes.default.SUPPORT, _actionMenuTypes.default.FAQ, _actionMenuTypes.default.BILLING]));

exports.default = _default;